import { useState, useEffect, useRef } from "react";

import { Spin } from "antd"
import { format } from "date-fns";
import { examinationList } from '../booking/constant/BookingConstant'

import Lightbox from "yet-another-react-lightbox";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

import axiosService from "../../utils/axios.service";
import "../booking/scss/examination.scss";

export function HistoryExamination(props) {
  const initialFormData = {
    examination_goal: {
      value: 0,
      note: ""
    },

    service_condition: [],
    conclude_condition: 0,

    skin_assessment: [],
    skin_assessment_note: "",

    hair_assessment: [],
    hair_assessment_note: "",

    treatment_assessment: [],
    treatment_assessment_note: "",

    treatment_instruction: [],
    treatment_instruction_adjustment: "",
    treatment_instruction_note: "",

    confirm_examination: {
      value: 0,
      note: ""
    }
  };
  const [dataExamination, setDataExamination] = useState(null);
  const [dataAnswers, setDataAnswers] = useState(null);
  const [existingImages, setExistingImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openLightbox, setOpenLightbox] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [openSections, setOpenSections] = useState({
    examination_goal: true,
    service_condition: false,
    skin_assessment: false,
    hair_assessment: false,
    treatment_assessment: false,
    treatment_instruction: false,
    confirm_examination: false,
    images: false
  });

  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const convertExaminationData = (data) => {
    const answers = data.answers || [];

    const getAnswersBySection = (section) => {
      const config = examinationList[section] || [];

      return answers
        .filter(item => item.section === section)
        .map(item => {
          const question = config.find(
            x => Number(x.key) === Number(item.question_key)
          );

          const answer = question?.answer?.find(
            x => Number(x.value) === Number(item.answer_value)
          );

          return {
            criteria: question?.criteria || "",
            title: answer?.title || "",
            note: item.note || ""
          };
        });
    };

    const getSingleAnswer = (section, value, note = "") => {
      const config = examinationList[section] || [];

      const answer = config.find(
        x => Number(x.value) === Number(value)
      );

      return {
        title: answer?.title || "",
        note: note || ""
      };
    };

    return {
      examination_goal: getSingleAnswer(
        "examination_goal",
        data.examination_goal,
        data.examination_goal_note
      ),
      service_condition: getAnswersBySection("service_condition"),
      conclude_condition: getSingleAnswer(
        "conclude_condition",
        data.conclude_condition
      ),
      skin_assessment: getAnswersBySection("skin_assessment"),
      skin_assessment_note: data.skin_assessment_note || "",
      hair_assessment: getAnswersBySection("hair_assessment"),
      hair_assessment_note: data.hair_assessment_note || "",
      treatment_assessment: getAnswersBySection("treatment_assessment"),
      treatment_assessment_note: data.treatment_assessment_note || "",
      treatment_instruction: getAnswersBySection("treatment_instruction"),
      treatment_instruction_adjustment: data.treatment_instruction_adjustment || "",
      treatment_instruction_note: data.treatment_instruction_note || "",
      confirm_examination: getSingleAnswer(
        "confirm_examination",
        data.confirm_examination,
        data.confirm_examination_note
      )
    };
  };

  useEffect(() => {
    const fetchData = async () => {
      let response = await axiosService(`api/examination/get-detail/${props?.examinationId}`, "GET");
      if (response.data.code == 200 && response.data.data) {    
        setDataExamination(response.data.data)
        setExistingImages(response.data.data.images || []);
        setDataAnswers(convertExaminationData(response.data.data))
      } else {
        setDataExamination(initialFormData)
      }
      setLoading(false)
    }
    fetchData()
  }, [props?.examinationId])

  return (
    <div className="popup-cent popup-examination">
      <div className="content-popup fadeInDown">
        <div className="head-popup">
          <div className="title">Phiếu thăm khám khách hàng</div>
          <div className="close" onClick={props.onClose}>×</div>
        </div>
        <Spin spinning={loading} size="large" tip="Đang tải...">
          <div className="body-popup">
            <div className="list-examination">
              <div className="item-examination">
                <div className="head-item">
                  <div className="title">I. THÔNG TIN THĂM KHÁM</div>
                </div>
                <div className="content-item">
                  <div className="item-question">
                    <div className="answer">
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Họ và tên:</div>
                          <div className="value bold">{props.customer.full_name}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Số điện thoại:</div>
                          <div className="value bold">{props.customer.mobile}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Ngày thăm khám:</div>
                          <div className="value">{dataExamination ? format(new Date(dataExamination?.created_at), "yyyy-MM-dd") : null}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Cơ sở:</div>
                          <div className="value">{dataExamination?.booking?.stores.name_store}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title">Tư vấn viên:</div>
                          <div className="value">{dataExamination?.user?.name}</div>
                        </div>
                      </div>
                      <div className="answer-item">
                        <div className="group-form group-info">
                          <div className="title w-100">Nhóm khách hàng:</div>
                          <div className="value w-100 text-left">
                            {(dataExamination?.booking?.bookingType || []).map((x, y) => (
                              <p key={y}>
                                {`- N${x.type}: ${
                                  x.type === 1 ? "Khách lần đầu sử dụng dịch vụ" : 
                                  x.type === 3 ? `Khách feedback ngày ${format(new Date(x.feed_back), "yyyy-MM-dd HH:mm:ss")}` : 
                                  x.type === 4 ? "Khách có nhu cầu tư vấn" : 
                                  x.package ? `${x.package.package_code} - ${x.package.product_name}` : ""
                                }`}
                              </p>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('examination_goal')}>
                  <div className="title">II. MỤC TIÊU BUỔI THĂM KHÁM</div>
                  <div className="desc">Chỉ chọn 01 mục tiêu chính</div>
                </div>
                
                <div className={`examination-content ${openSections.examination_goal ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    {dataAnswers?.examination_goal ?
                      <div className="content-item">
                        <div className="item-question">
                          <div className="answer">
                            <div className="answer-item">
                              <div className={`group-form group-radio`}>
                                <label className={`d-flex align-items-center`}>
                                  <input type="radio" name="target" value={dataAnswers?.examination_goal.title} checked readOnly />
                                  <i className="fa-solid fa-check"></i>
                                  <div className="text">{dataAnswers?.examination_goal.title}</div>
                                </label>
                              </div>
                            </div>
                            {dataAnswers?.examination_goal.note != "" && (<textarea value={dataAnswers?.examination_goal.note || ""} readOnly />)}
                          </div>
                        </div>
                      </div>
                    : null}
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('service_condition')}>
                  <div className="title">III. ĐÁNH GIÁ ĐIỀU KIỆN LÀM DỊCH VỤ</div>
                  <div className="desc">(Mục tiêu: Khách có đủ điều kiện thực hiện dịch vụ tại thời điểm thăm khám hay không)</div>
                </div>
                <div className={`examination-content ${openSections.service_condition ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    {dataAnswers?.service_condition?.length > 0 ?
                      <div className="content-item">
                        {dataAnswers?.service_condition.map((x,y) => {
                          return (
                            <div className="item-question" key={y}>
                              <div className="question">{`${y+1}. ${x.criteria}`}</div>
                              <div className="answer row">
                                <div className="answer-item w-100">
                                  <div className={`group-form group-radio`}>
                                    <label className={`d-flex align-items-center`}>
                                      <input type="radio" name={`condition_${y}`} value={x.title} checked readOnly />
                                      <i className="fa-solid fa-check"></i>
                                      <div className="text">{x.title}</div>
                                    </label>
                                  </div>
                                </div>
                                {x?.note != "" && (<textarea value={x?.note || ""} readOnly />)}
                              </div>
                            </div>
                          )
                        })}
                        {dataAnswers?.conclude_condition?.title ?
                          <div className="item-question">
                            <div className="question">{`${dataAnswers?.service_condition.length + 1}. Kết luận`}</div>
                            <div className="answer row">
                              <div className="answer-item w-100">
                                <div className={`group-form group-radio`}>
                                  <label className={`d-flex align-items-center`}>
                                    <input type="radio" name="conclude_condition" value={dataAnswers?.conclude_condition.title} checked readOnly />
                                    <i className="fa-solid fa-check"></i>
                                    <div className="text">{dataAnswers?.conclude_condition.title}</div>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        :null}
                      </div>
                    :null}
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('skin_assessment')}>
                  <div className="title">IV. ĐÁNH GIÁ TÌNH TRẠNG DA</div>
                  <div className="desc">Mục tiêu: Đánh giá tình trạng da để quyết định thông số cho từng vùng</div>
                </div>
                <div className={`examination-content ${openSections.skin_assessment ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    {dataAnswers?.skin_assessment?.length > 0 ?
                      <div className="content-item">
                        {dataAnswers?.skin_assessment.map((x,y) => {
                          return (
                            <div key={y} className="item-question">
                              <div className="question">{`${y+1}. ${x.criteria}`}</div>
                              <div className="answer row">
                                <div className="answer-item w-100">
                                  <div className={`group-form group-radio`}>
                                    <label className={`d-flex align-items-center`}>
                                      <input type="radio" name={`skin_assessment_${y}`} value={x.title} checked readOnly />
                                      <i className="fa-solid fa-check"></i>
                                      <div className="text">{x.title}</div>
                                    </label>
                                  </div>
                                </div>
                                {x?.note != "" && (<textarea value={x?.note || ""} readOnly />)}
                              </div>
                            </div>
                          )
                        })}
                        {dataAnswers?.skin_assessment_note != "" ? 
                          <div className="item-question">
                            <div className="question">{`${dataAnswers?.skin_assessment.length + 1}. Nhận định của tư vấn viên`}</div>
                            <div className="answer">
                              <div className="answer-item">
                                <div className={`group-form group-textarea`}>
                                  <textarea readOnly value={dataAnswers?.skin_assessment_note || ""} />
                                </div>
                              </div>
                            </div>
                          </div>
                        :null}
                      </div>
                    :null}
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('hair_assessment')}>
                  <div className="title">V. ĐÁNH GIÁ TÌNH TRẠNG LÔNG</div>
                </div>
                <div className={`examination-content ${openSections.hair_assessment ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    {dataAnswers?.hair_assessment?.length > 0 ?
                      <div className="content-item">
                        {dataAnswers?.hair_assessment.map((x,y) => {
                          return (
                            <div key={y} className="item-question">
                              <div className="question">{`${y+1}. ${x.criteria}`}</div>
                              <div className="answer row">
                                <div className="answer-item w-100">
                                  <div className={`group-form group-radio`}>
                                    <label className={`d-flex align-items-center`}>
                                      <input type="radio" name={`hair_assessment_${y}`} value={x.title} checked readOnly />
                                      <i className="fa-solid fa-check"></i>
                                      <div className="text">{x.title}</div>
                                    </label>
                                  </div>
                                </div>
                                {x?.note != "" && (<textarea value={x?.note || ""} readOnly />)}
                              </div>
                            </div>
                          )
                        })}
                        {dataAnswers?.hair_assessment_note != "" ?
                          <div className="item-question">
                            <div className="question">{`${examinationList.hair_assessment.length + 1}. Vùng lông phát triển mạnh`}</div>
                            <div className="answer">
                              <div className="answer-item">
                                <div className={`group-form group-textarea`}>
                                  <textarea value={dataAnswers?.hair_assessment_note || ""} readOnly />
                                </div>
                              </div>
                            </div>
                          </div>
                        :null}
                      </div>
                    :null}
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('treatment_assessment')}>
                  <div className="title">VI. ĐÁNH GIÁ HIỆU QUẢ DỊCH VỤ</div>
                  <div className="desc">Không áp dụng với khách hàng thuộc nhóm N1</div>
                </div>
                <div className={`examination-content ${openSections.treatment_assessment ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    {dataAnswers?.treatment_assessment.length ?
                      <div className="content-item">
                        {dataAnswers?.treatment_assessment.map((x,y) => {
                          return (
                            <div key={y} className="item-question">
                              <div className="question">{`${y+1}. ${x.criteria}`}</div>
                              <div className="answer row">
                                <div className="answer-item w-100">
                                  <div className={`group-form group-radio`}>
                                    <label className={`d-flex align-items-center`}>
                                      <input type="radio" name={`treatment_assessment_${y}`} value={x.title} checked readOnly />
                                      <i className="fa-solid fa-check"></i>
                                      <div className="text">{x.title}</div>
                                    </label>
                                  </div>
                                </div>
                                {x?.note != "" && (<textarea value={x?.note || ""} readOnly />)}
                              </div>
                            </div>
                          )
                        })}
                        {dataAnswers?.treatment_assessment_note != "" ?
                          <div className="item-question">
                            <div className="question">{`${examinationList.treatment_assessment.length + 1}. Đánh giá hiệu quả`}</div>
                            <div className="answer">
                              <div className="answer-item">
                                <div className={`group-form group-textarea`}>
                                  <textarea readOnly value={dataAnswers?.treatment_assessment_note || ""} />
                                </div>
                              </div>
                            </div>
                          </div>
                        :null}
                      </div>
                    :null}
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('treatment_instruction')}>
                  <div className="title">VII. CHỈ ĐỊNH CHO CHUYÊN VIÊN DỊCH VỤ</div>
                </div>
                <div className={`examination-content ${openSections.treatment_instruction ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    {dataAnswers?.treatment_instruction.length > 0 ?
                      <div className="content-item">
                        {dataAnswers?.treatment_instruction.map((x,y) => {
                          return (
                            <div key={y} className="item-question">
                              <div className="question">{`${y+1}. ${x.criteria}`}</div>
                              <div className="answer row">
                                <div className="answer-item w-100">
                                  <div className={`group-form group-radio`}>
                                    <label className={`d-flex align-items-center`}>
                                      <input type="radio" name={`treatment_instruction_${y}`} value={x.title} checked readOnly />
                                      <i className="fa-solid fa-check"></i>
                                      <div className="text">{x.title}</div>
                                    </label>
                                  </div>
                                </div>
                                {x?.note != "" && (<textarea value={x?.note || ""} readOnly />)}
                              </div>
                            </div>
                          )
                        })}
                        {dataAnswers?.treatment_instruction_adjustment != "" ?
                          <div className="item-question">
                            <div className="question">{`${dataAnswers?.treatment_instruction.length + 1}. Điều chỉnh kỹ thuật`}</div>
                            <div className="answer">
                              <div className="answer-item">
                                <div className={`group-form group-textarea`}>
                                  <textarea readOnly value={dataAnswers?.treatment_instruction_adjustment || ""} />
                                </div>
                              </div>
                            </div>
                          </div>
                        :null}
                        {dataAnswers?.treatment_instruction_note != "" ?
                          <div className="item-question">
                            <div className="question">{`${dataAnswers?.treatment_instruction.length + 2}. Lưu ý khi thực hiện`}</div>
                            <div className="answer">
                              <div className="answer-item">
                                <div className={`group-form group-textarea`}>
                                  <textarea readOnly value={dataAnswers?.treatment_instruction_note || ""} />
                                </div>
                              </div>
                            </div>
                          </div>
                        :null}
                      </div>
                    :null}
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection('confirm_examination')}>
                  <div className="title">VIII. XÁC NHẬN THĂM KHÁM</div>
                </div>
                <div className={`examination-content ${openSections.confirm_examination ? 'show' : ''}`}>
                  <div className="examination-content-inner">
                    {dataAnswers?.confirm_examination?.title ?
                      <div className="content-item">
                        <div className="item-question">
                          <div className="answer">
                            <div className="answer-item">
                              <div className={`group-form group-radio`}>
                                <label className={`d-flex align-items-center`}>
                                  <input type="radio" name="confirm_examination" value={dataAnswers?.confirm_examination.title} checked readOnly />
                                  <i className="fa-solid fa-check"></i>
                                  <div className="text">{dataAnswers?.confirm_examination.title}</div>
                                </label>
                              </div>
                            </div>
                            {dataAnswers?.confirm_examination.note === 2 ? 
                              <textarea value={dataAnswers?.confirm_examination.note || ""} readOnly />
                            :null}
                          </div>
                        </div>
                      </div>
                    :null}
                  </div>
                </div>
              </div>
              <div className="item-examination">
                <div className="head-item" onClick={() => toggleSection("images")}>
                  <div className="title">IX. HÌNH ẢNH</div>
                </div>
                <div className={`examination-content ${openSections.images ? "show" : ""}`}>
                  <div className="examination-content-inner">
                    <div className="content-item">
                      <div className="item-question">
                        <div className="answer">
                          <div className="image-preview-list">
                            {existingImages.map((image, index)=> (
                              <div className="image-preview-item" key={index}
                              onClick={() => {setLightboxIndex(index); setOpenLightbox(true)}}>
                                <img src={image.file_url} alt={image.file_name} />
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-popup">
            <div className="button-container">
              <div className="button-cent style3" onClick={props.onClose}>
                <span><i className="fas fa-times"></i></span>Đóng
              </div>
            </div>
          </div>
        </Spin>
      </div>
      <>
        <Lightbox className={"light-box"} open={openLightbox} close={() => setOpenLightbox(false)} index={lightboxIndex}
          slides={existingImages.map((image) => ({ src: image.file_url, alt: image.file_name})) || []}
          plugins={[Thumbnails, Zoom]}
          zoom={{
            maxZoomPixelRatio: 3,
            scrollToZoom: true,
          }}
        />
      </>

      <div className="overlay" onClick={() => props.overflowClose ? props.onClose() : null}></div>
    </div>
  );
}
